/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContrattoResDto } from '../../models/contratto-res-dto';
import { CreateContrattoDto } from '../../models/create-contratto-dto';

export interface ContrattiControllerCreateContratto$Params {
  body: CreateContrattoDto;
}

export function contrattiControllerCreateContratto(
  http: HttpClient,
  rootUrl: string,
  params: ContrattiControllerCreateContratto$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<ContrattoResDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    contrattiControllerCreateContratto.PATH,
    'post',
  );
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ContrattoResDto>;
      }),
    );
}

contrattiControllerCreateContratto.PATH = '/admin/contratti';
